import { Injectable } from '@angular/core';
import { HttpWrapperService } from './httpWrapper.service';
import { URLService } from './urls.service';
import { UserService } from './user.service';
import { Subject } from 'rxjs';

@Injectable()
export class PurchaseOrderService {
  poAdded: Subject<boolean> = new Subject<boolean>();

  constructor(private httpWrapper: HttpWrapperService, private url: URLService,
              private userService: UserService) {

  }

  getPurchaseOrders(companyId, inputJSON) {
    const purchaseOrderUrl = this.url.purchaseOrderUrl + '?companyId=' + companyId;
    return this.httpWrapper.get(purchaseOrderUrl, inputJSON);
  }

  searchPurchaseOrders(inputJSON){
    const purchaseOrderUrl = this.url.purchaseOrderUrl + '/search';
    return this.httpWrapper.post(purchaseOrderUrl, inputJSON);
  
  }
  getPurchaseOrder(id) {
    const purchaseOrderUrl = this.url.purchaseOrderUrl + `/${id}`;
    return this.httpWrapper.get(purchaseOrderUrl);
  }

  savePurchaseOrder(inputJSON) {
    const purchaseOrderUrl = this.url.purchaseOrderUrl;
    return this.httpWrapper.post(purchaseOrderUrl, inputJSON);
  }

 
  uploadPurchaseOrder(fileToUpload: File, invoice_number) {
    const fileUploadURL = this.url.uploadDocument + '?referenceId=' + invoice_number + '&documentType=PURCHASE_ORDER';
    return this.httpWrapper.uploadFile(fileUploadURL, fileToUpload);

  }

  updatePOStatus(invoiceJSON) {
    const updatePOStatus = this.url.updatePOStatus;
    return this.httpWrapper.patch(updatePOStatus, invoiceJSON);
  }

}
